import { createNextTableContext } from '@core/table';

export const PlansTableContext = createNextTableContext();
